const SDK_VERSION = "10.58.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
